// extracted by mini-css-extract-plugin
export default {"footer_outer":"suqriuPwXHuDJMH-6r2PHA==","footer_inner":"+BaLY0xk31AZ9m7Tlwo1iw==","clear_button":"MjIGr0vUdMFfnf0T03G1rA==","save_button":"GcZwOObbCIRmad3XA2LZeg=="};